import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import type { ForgotPasswordPayload } from "@domain/models/User";
import { authentication } from "@services/auth/AuthService";
export const useForgotPasswordMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
function _temp(payload) {
  return authentication.forgotPassword(payload);
}